import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=fb8820fa&scoped=true"
import script from "./nav.vue?vue&type=script&lang=ts"
export * from "./nav.vue?vue&type=script&lang=ts"
import style0 from "./nav.vue?vue&type=style&index=0&id=fb8820fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8820fa",
  null
  
)

export default component.exports